import {createAction, props} from '@ngrx/store';
import {NpsResponse} from 'src/app/services/widgets.service';

export const loadCurrentNPS = createAction(
    '[NPS] Load Current NPS With Target',
    props<{
        key: string;
        payload: any;
    }>()
);

export const loadCurrentNPSSuccess = createAction(
    '[NPS] Load Current NPS With Target Success',
    props<{ data: any; key: string; payload: any; }>()
);

export const loadCurrentNPSFailure = createAction(
    '[NPS] Load Current NPS With Target Failure',
    props<{ error: any }>()
);
